import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Skeleton } from '../components/ui/skeleton';
import { WalletsTab } from '../components/settings/wallets-tab';
import { ChainsTab } from '../components/settings/chains-tab';
import { SecretsTab } from '../components/settings/secrets-tab';
import { CompanyTab } from '../components/settings/company-tab';
import { ReconciliationTab } from '../components/settings/reconciliation-tab';
import { useChains, useWallets } from '../lib/api/hooks/use-queries';

function SettingsPage(): JSX.Element {
  const chains = useChains();
  const wallets = useWallets();

  if (chains.isLoading || wallets.isLoading) return <Skeleton className="h-48" />;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Paramètres</CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="wallets">
          <TabsList>
            <TabsTrigger value="wallets">Wallets</TabsTrigger>
            <TabsTrigger value="chains">Chaînes</TabsTrigger>
            <TabsTrigger value="prix">Prix &amp; API</TabsTrigger>
            <TabsTrigger value="reconciliation">Réconciliation</TabsTrigger>
            <TabsTrigger value="societe">Société</TabsTrigger>
          </TabsList>
          <TabsContent value="wallets">
            <WalletsTab />
          </TabsContent>
          <TabsContent value="chains">
            <ChainsTab />
          </TabsContent>
          <TabsContent value="prix">
            <SecretsTab />
          </TabsContent>
          <TabsContent value="reconciliation">
            <ReconciliationTab />
          </TabsContent>
          <TabsContent value="societe">
            <CompanyTab />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}

export const Route = createFileRoute('/settings')({ component: SettingsPage });
